import LoyaltySlider from './loyalty-slider.vue';

export default LoyaltySlider;
